import { Component, Input } from "@angular/core";
import { CommonModule } from "@angular/common";

type LoadingColor = "primary" | "white";

@Component({
  selector: "app-loading",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./loading.component.html",
  styleUrls: ["./loading.component.scss"],
})
export class LoadingComponent {
  @Input() color: LoadingColor | undefined = "primary";
  @Input() inline: boolean = false;
  @Input() size: number | undefined = 8;

  getStyles() {
    return {
      "--loading-color": `${this.color}`,
      "--loading-size": `${this.size}px`,
    };
  }
}
